import React, { FC } from 'react';
import clsx from 'clsx';
import { EditableComponent } from '@adobe/aem-react-editable-components';

import { OBannerFeature, OBannerFeatureProps } from '@marriott/mi-web-ui-kit';
import { cobrandOBannerFeature } from './CobrandOBannerFeature.types';
import { StyledCobrandOBannerFeature } from './CobrandOBannerFeature.styles';

export const cobrandOBannerFeatureConfig = {
  emptyLabel: 'CobrandOBannerFeature',
  isEmpty: () => false,
  resourceType: 'mi-aem-utils/components/content/o-banner-feature',
};

export const CobrandOBannerFeatureComp: FC<cobrandOBannerFeature> = props => {
  const model = (props.model || props) as OBannerFeatureProps & { styleclass?: string; componentId?: string };
  const { styleclass, componentId, ...bannerProps } = model;

  return (
    <StyledCobrandOBannerFeature
      data-testid="cobrand-CobrandOBannerFeature"
      data-component-name="o-cobrand-CobrandOBannerFeature"
      id={componentId}
      className={clsx(styleclass, 'fullbleed m-container-fullbleed standard t-background-color mb-5')}
    >
      <div className="container py-5">
        <OBannerFeature {...(bannerProps as OBannerFeatureProps)} />
      </div>
    </StyledCobrandOBannerFeature>
  );
};

CobrandOBannerFeatureComp.displayName = 'CobrandOBannerFeatureComp';

export const CobrandOBannerFeature = (props: cobrandOBannerFeature) => {
  return (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <EditableComponent config={cobrandOBannerFeatureConfig} {...(props as any)}>
      <CobrandOBannerFeatureComp {...props} />
    </EditableComponent>
  );
};
